/**
 * Reading money the operator typed.
 *
 * Everything on the wire is integer cents. What arrives from a text input is whatever a
 * person typed into it, which on this screen is a refund amount, so the parse has to be
 * strict rather than forgiving: `parseFloat('20 or so')` is 20, and a refund is not a place
 * for a helpful guess.
 *
 * Rejected: an empty string, anything that is not a plain number, a negative, more than two
 * decimal places, and anything that would not land on a whole cent.
 */
export function parseDollars(text: string): number | null {
  const trimmed = text.trim().replace(/^\$/, '').replace(/,/g, '');
  if (trimmed === '') return null;
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return null;
  const cents = Math.round(Number(trimmed) * 100);
  return Number.isSafeInteger(cents) ? cents : null;
}

/** Cents as the digits a money input should start with. No symbol, no thousands separator. */
export function centsToInput(cents: number): string {
  return (cents / 100).toFixed(2);
}
